export const minutesBetween = (start, end) => Math.max(1, Math.round((end - start) / 60000));

export const findTimeOptionIndex = (start, end) => {
  const diffMinutes = minutesBetween(start, end);
  const matchIndex = TIME_PERIOD_OPTIONS.findIndex((option) => option.value === diffMinutes);
  return matchIndex >= 0 ? matchIndex : 0;
};

// Format x-axis labels nicely depending on the range
export function xAxisLabelFormatter(minutesBetween) {
  return (value) => {
    // value is whatever you put in labels (likely a datetime string)
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    // <= 1 hour: show time with seconds
    if (minutesBetween <= 60) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    }

    // <= 1 day: show HH:MM only
    if (minutesBetween <= 1440) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    // <= 7 days: show "M/D HH:MM"
    if (minutesBetween <= 10080) {
      return (
        `${date.getMonth() + 1}/${date.getDate()} ` +
        date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })
      );
    }

    // > 7 days: just show date
    return `${date.getMonth() + 1}/${date.getDate()}`;
  };
}

// Convert various timestamp representations to milliseconds since epoch.
// - Numbers in seconds are assumed to be in seconds and converted to ms.
// - Numbers already in ms are returned as-is.
// - Numeric strings are parsed and normalized.
// - Date strings are parsed via Date.parse.
export function toTimestampMs(value) {
  if (value == null) return NaN;

  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return NaN;
    // Heuristic: values < 1e12 are seconds, convert to ms
    return value < 1e12 ? Math.floor(value * 1000) : Math.floor(value);
  }

  if (typeof value === 'string') {
    const asNum = Number(value);
    if (!Number.isNaN(asNum) && asNum !== 0) {
      return toTimestampMs(asNum);
    }
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? NaN : parsed;
  }

  if (value instanceof Date) return value.getTime();

  return NaN;
}

export function isValidTimestamp(value) {
  const t = toTimestampMs(value);
  return Number.isFinite(t) && !Number.isNaN(t);
}
